module.exports = __webpack_public_path__ + "static/media/timelapse_13.3de9cfc6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Kiosk/WoodburningView/timelapse_13.jpg
// module id = 971
// module chunks = 0